/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Attachments/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CommsThreadEventAttachments from 'DesignSystem/CommsThreadEventAttachments/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Attachments({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Inbound/Attachments"
  
}) {
let smsIdValueData = fromData.useDataValue({ viewPath,
context: 'sms',
path: 'id',
})
  return (<React.Fragment
>
<CommsThreadEventAttachments
  viewPath={`${viewPath}/CommsThreadEventAttachments`}
 data="sms.id"
 event_id={smsIdValueData}
/>
{children}
</React.Fragment>)
}